// @ts-nocheck
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = `${process.env.REACT_APP_API_URL}/roomtype`; // Replace with your actual API URL

const customHeaders = {
    'Content-Type': 'application/json'
  };

// Get all room types
        //  @ts-ignore 

export const fetchRoomTypesTable = async (page,limit) => {
  const response = await axios.get(`${API_URL}/table/?page=${page}&limit=${limit}`,{headers: customHeaders});
  return response.data;
};

export const fetchRoomTypes = async () => {
  const response = await axios.get(`${API_URL}`,{headers: customHeaders});
  return response.data;
};

export const fetchRoomTypeById = async (id: string) => {
    const response = await axios.get(`${API_URL}/${id}`, { headers: customHeaders });
    return response.data;
  };
// Create a new room type
export const addRoomType = async (newRoomType: any) => {
  try {
    
    const response = await axios.post(API_URL, newRoomType,{headers: {
      'Content-Type': 'multipart/form-data'
    }});
    return response.data;
  } catch (error) {
    console.log(error?.response?.data?.errors,'err');
    error?.response?.data?.errors && error?.response?.data?.errors.forEach(err => {
      console.log(err,'errrrrrrrrrr');
      toast.error(err.msg)
      
      
    });
  }
};

// Edit an existing room type
export const updateRoomType = async (id: string, updatedRoomType: any) => {
  const response = await axios.put(`${API_URL}/${id}`, updatedRoomType,{headers: {
    'Content-Type': 'multipart/form-data'
  }});
  return response.data;
};

// Delete a room type
export const removeRoomType = async (id: string) => {
  const response = await axios.delete(`${API_URL}/${id}`,{headers: customHeaders});
  return response.data;
};
